module.exports = __webpack_public_path__ + "static/media/Expense-Manage.f5d42a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/expense/Expense-Manage.png
// module id = 116
// module chunks = 0